var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCilBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--ci-primary-color, currentColor)",
    d: "M440,464V16H72V464H16v32H496V464Zm-32,0H272V400H240v64H104V48H408Z",
    className: "ci-primary"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 160,
    y: 304,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 240,
    y: 304,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 320,
    y: 304,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 160,
    y: 208,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 240,
    y: 208,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 320,
    y: 208,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 160,
    y: 112,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 240,
    y: 112,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 320,
    y: 112,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilBuilding);
export default __webpack_public_path__ + "static/media/cil-building.00b9717e12f8e4489af775351d9cca95.svg";
export { ForwardRef as ReactComponent };